import { useEffect, useState } from "react";

/**
 *
 * @param {object} history the history object as @oss/components does not fall within the router
 * @param {bool} allowRouteBlock if true, routing will be blocked for the user
 * @param {bool} enabled force the hook to wait for a value before allowing route blocking
 */
const useHistoryBlock = ({ history, allowRouteBlock, enabled = true }) => {
  const [nextRoute, setNextRoute] = useState(null);
  useEffect(() => {
    if (enabled) {
      // history.block allows us to detect pathname changes within the application
      history.block(location => {
        // If query is updating, just allow it to happen
        if (location.pathname === window.location.pathname || !allowRouteBlock)
          return true;
        // If they are trying to leave
        // Block Routing and save path if is modified
        setNextRoute(location.pathname);
        return false;
      });
    }
  }, [allowRouteBlock, history, enabled]);

  return {
    nextRoute,
    setNextRoute
  };
};

export default useHistoryBlock;
